'use strict';

var debounce = require('lodash/debounce');

var updateOptionSelection = debounce(function(inputValue, inputOptionID, inputPrice, $productContainer) {
    // don't trigger 'change' here, otherwise it'll go in a loop.
    if (inputValue && inputValue.length > 0) {
        $productContainer.find('[data-option-id=' + inputOptionID + '] .js-Engraving option[data-price="' + inputPrice + '"]').prop('selected', true).change();
    } else {
        $productContainer.find('[data-option-id=' + inputOptionID + '] .js-Engraving option[data-price="$0.00"]').prop('selected', true).change();
    }
}, 500);

function applyEngravingSelections(data) {
    $('.js-finalBuild-engraving-input').val(JSON.stringify(data));
    var engravingSections = data;
    var engraving = $('.main-product .engraving');

    engravingSections.forEach(function (section) {
        var positionInput;
        var position;
        // Engraving position (head/tube/hammer)
        var positionArray = engraving.find('.engravingLocationCode[data-code=' + section.code + ']');
        positionArray.each(function(){
            position = $(this).data('location');
            positionInput = engraving.find('.js-addEngraving[data-option=' + position + ']');
            if(positionInput.length > 0){
                return false;
            }
        })

        // Engraving font and text
        var font = '';
        var text = '';

        // Parse font/text
        if (section.font) {
            font = section.font;
        } 
        text = section.text;

        // Apply font
        if (font.length > 0) {
            var fontName = getFontName(font);
            engraving.find('select.js-engStyle').selectpicker('val', font);
            $('#personalization1Preview').css('font-family', fontName);
            if ($('.pdp-mid-section .detail-images #personalization1Preview').length > 0) {
                $('.pdp-mid-section .detail-images #personalization1Preview').css('font-family', fontName);
            }
            $('.js-primary').css('font-family', fontName).attr('data-font', font);
        }

        // Apply text
        positionInput.val(text);
        if (position == "engravingHeadOption" || position == "engravingHammerOption") {
            $('#personalization1Preview textPath').text(text);
        } else {
            // tube
            $('#personalization2Preview textPath').text(text.toUpperCase());
        }
    });

    showHideDisclaimer();
}

function resetEngravingSelections() {
    var $engraving = $('.engraving');
    $engraving.find('select.selectpicker').prop('selectedIndex', 0);
    $engraving.find('select.selectpicker').selectpicker('refresh');
    $engraving.find('.js-addEngraving').val('').removeAttr('style');
    $engraving.find('.data-engraving').val('');
}

function getInputText(position) {
    var inputText = '';

    if (position == 'primary') {
        inputText = $('.js-primary').val();
    } else if (position == 'secondary') {
        inputText = $('.js-secondary').val() && $('.js-secondary').val().length > 0 ? $('.js-secondary').val().toUpperCase() : '';
    }

    return inputText;
}

function getEngravingHtmlTemplate(position) {
    var inputText = '';
    var inputFont = '';
    if (position == "primary") {
        var positionNumber = '1';
        var image = $('.js-primaryImage').text() || '';
        var fontTextPath = $('.js-primaryTextPath').text() || '';
        var fontRotation = $('.primaryFontRotation').length && $('.primaryFontRotation').text() == "undefined" || $('.primaryFontRotation').text() == "" ? 0 : $('.primaryFontRotation').text();
        var fontColor = $('.js-primaryFontColor').length ? '#' + $('.js-primaryFontColor').text() : '';
        var fontSize = $('.js-primaryFontSize').text() || '';
        var fontSpacing = $('.js-primaryFontSpacing').text() != 'null' ? $('.js-primaryFontSpacing').text() : 0;
        var viewBoxSize = '25 -18 180 585';

        // Reapply text/font
        if ($('.js-primary').val() && $('.js-primary').val().length > 0) {
            inputText = getInputText(position);
            var fontValue = $('select.js-engStyle').val() || '';
            var fontName = getFontName(fontValue);
            inputFont = '&quot;' + fontName + '&quot;';
            $('.js-primary').css('font-family', fontName).attr('data-font', fontName);
        }
    } else if (position == "secondary") {
        // secondary engraving data here
        var positionNumber = '2';
        var image = $('.js-secondaryImage').text() || '';
        var fontTextPath = $('.js-secondaryTextPath').text() || '';
        var fontRotation = $('.secondaryFontRotation').length && $('.secondaryFontRotation').text() == "undefined" || $('.secondaryFontRotation').text() == "" ? 0 : $('.secondaryFontRotation').text();
        var fontColor = $('.js-secondaryFontColor').length ? '#' + $('.js-secondaryFontColor').text() : '';
        var fontSize = $('.js-secondaryFontSize').text() || '';
        var fontSpacing = $('.js-secondaryFontSpacing').text() != 'null' ? $('.js-secondaryFontSpacing').text() : 0;
        var viewBoxSize = '-80 -65 378 175';

        // Reapply text/font
        if ($('.js-secondary').val().length > 0) {
            inputText = getInputText(position);
        }
    }

    var html = "";
    html += '  <svg preserveAspectRatio="xMinYMin meet" id="personalization'+ positionNumber +'Preview" viewBox="' + viewBoxSize + '" class="' + '' + '" width="100%" height="100%" data-font="" data-background-image="' + image + '" style="font-family:'+ inputFont +';background-image:url(' + image + '); background-size: contain; background-repeat: no-repeat;" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">';
    html += '    <defs>';
    html += '      <path id="personalizationPath'+ positionNumber +'" d="' + fontTextPath + '"></path>';
    html += '    </defs>';
    html += '    <use xlink:href="#personalizationPath' + positionNumber + '" fill="none"></use>';
    html += '    <text text-anchor="middle" rotate="' + fontRotation + '" fill="' + fontColor + '" data-font-size="' + fontSize + '" font-size="' + fontSize + '" data-spacing="' + fontSpacing + '" style="letter-spacing:' + fontSpacing + ';">';
    html += '      <textPath id="personalizationPath' + positionNumber + 'Text" startOffset="50%" xlink:href="' + window.location.href + '#personalizationPath' + positionNumber +'">'+ inputText +'</textPath>';
    html += '    </text>';
    html += '  </svg>';

    return html;
}

function updateEngraving() {
    if ($('.js-primaryTextPath').length) {
        var primaryHTML = getEngravingHtmlTemplate('primary');
        $('.personalization-image__1').prepend(primaryHTML);
    }
    if ($('.js-secondaryTextPath').length) {
        var secondaryHTML = getEngravingHtmlTemplate('secondary');
        $('.personalization-image__2').prepend(secondaryHTML);
    }
}

function getFontName(txt) {
    var font = '';

    switch (txt) {
        case 'Block':
            font = 'Arial Ultra Compact';
            break;
        case 'expo':
            font = 'Exo2';
            break;
        case 'grand view':
            font = 'Grand Hotel';
            break;
        case 'grandview':
            font = 'Grand Hotel';
            break;
        case 'curve pro':
            font = 'Learning Curve';
            break;
        case 'museo':
            font = 'MuseoSlab500';
            break;
        case 'script':
            font = '"Brush Script MT", SnellRoundhand';
            break;
        default:
            font = '';
    }

    return font;
}

function updateFontstyle() {
    $('select.js-engStyle').on('change', function () {
        var fontValue = $(this).val();
        var fontName = getFontName(fontValue);
        $('#personalization1Preview').css('font-family', fontName);
        if ($('.pdp-mid-section .detail-images #personalization1Preview').length > 0) {
            $('.pdp-mid-section .detail-images #personalization1Preview').css('font-family', fontName);
        }
        $('.js-primary').css('font-family', fontName).attr('data-font', fontValue);

        buildInputString();
    });
}

function updateText() {
    $('.js-addEngraving').on('input keyup change paste', function (e) {
        $(this).val($(this).val().replace(/[^a-z0-9 !',.-]/gi, ''));
        var enteredText = $(this).val().trim();
        var isTube = $(this).hasClass('js-engraving-tube');
        var isHandle = $(this).hasClass('js-engraving-handle');
        if (isTube || isHandle) {
            // update second position image
            var uppercasedText = $(this).val().toUpperCase();
            $(this).val(uppercasedText);
            if(isTube){
                $('#personalization2Preview textPath').text(uppercasedText);
            } else {
                $('#personalization1Preview textPath').text(uppercasedText);
            }
        } else {
            $('#personalization1Preview textPath').text(enteredText);
        }

        buildInputString();

        var inputOptionID = $(this).data('option');
        var inputPrice = $(this).data('price');
        $('.prod-slider').addClass('js-currentActive');

        var $productContainer = $(this).closest('.js-main-product');
        updateOptionSelection(enteredText, inputOptionID, inputPrice, $productContainer);
    });
}

function showPersonalization() {
    $('.js-addEngraving').on('focus', function () {
        var personalizationIcon = $('#personalization1Icon');
        if (!personalizationIcon.hasClass('slick-current')) {
            personalizationIcon.click();
        }
    });
}

// Reselects personalize slide if user is currently on it after clicking a variant
function reselectPersonalizationSlide() {
    if ($('.js-engravingData').hasClass('js-isCurrent')) {
        setTimeout(function () {
            $('#personalization1Icon').click();
            $('.js-engravingData').removeClass('js-isCurrent')
        }, 500);
    }
}

function checkIfEngraveSlide() {
    // On before slide change
    $('.pdp-carousel-nav-vertical').on('beforeChange', function (event, slick, currentSlide, nextSlide) {
        if ($(".pdp-carousel-nav-vertical .prod-slider__item[data-slick-index='" + nextSlide + "']").attr('id') == "personalization1Icon") {
            // used to keep on current personalize slide
            $('.js-engravingData').addClass('js-isCurrent');
        }
    });
}

function buildSinglePersonalization(code, price, font, text) {
    //CODE,,0.00,N,font~inputtext
    font = code === '701' ? '' : font + '~';  // Don't include font for tube (code 701)
    var fullLine = code + ",," + price + ",N," + font + text;

    return fullLine;
}
function buildEngravingObject(code, price, font, text){

    var engravingObject = {
        "code":code, "price":price,"text":text
    }
    if(code !== '701'){
        engravingObject.font= font
    }
    return engravingObject
}

function buildInputString() {
    var allInputs = [];
    $('.js-addEngraving').each(function () {
        var input = $(this);

        if (input.val().trim()) {
            var inputOptionID = input.data('option');
            var priceData = input.data('price');
            var inputPrice = typeof priceData !== 'undefined' && priceData !== null ? priceData.replace("$", '') : '';
            var engravingCode = $(".engravingLocationCode[data-location=" + inputOptionID + "]").attr('data-code');
            var font = $('select.js-engStyle').val();
            var getEnrgavingObjects = buildEngravingObject(engravingCode, inputPrice, font, input.val());
            allInputs.push(getEnrgavingObjects);
        }
    })
    var finalString = JSON.stringify(allInputs);

    $('.js-finalBuild-engraving-input').val(finalString);
}

function showHideDisclaimer() {
    var primary = $('.js-primary') && $('.js-primary').val() ? $('.js-primary').val() : '';
    var secondary = $('.js-secondary') && $('.js-secondary').val() ? $('.js-secondary').val() : '';

    if (primary.length > 0 || secondary.length > 0) {
        $('.engraving_disclaimer').show();
    } else {
        $('.engraving_disclaimer').hide();
    }
}

module.exports = {
    init: function () {
        if ($('.js-engravingData') && $('.js-engravingData').length > 0) {
            updateEngraving();
            updateFontstyle();
            updateText();
            showPersonalization();
            checkIfEngraveSlide();
        }
    },

    reinitEngraving: function() {
        $('.js-engravingData').on('blur', function () {
            reselectPersonalizationSlide();
            showHideDisclaimer();
            updateEngraving();
            updateFontstyle();
            showPersonalization();
            checkIfEngraveSlide();
        });
    },

    // Loading cart PLI selections back onto PDP
    reloadEngravingSelections: function () {
        if ($('.data-engraving').length > 0) {
            var data = $('.data-engraving').data('engraving-saved');

            if (data && data.length > 0) {
                applyEngravingSelections(data);
            } else {
                // Clear any existing engraving selections
                resetEngravingSelections();
            }
        }
    },
    triggerShowHideDisclaimer: function () {
        $('.js-addEngraving').on('change keyup paste', function () {
           showHideDisclaimer();
        });
    }
};
